<template>
  <v-container>
    <v-row>
      <v-col>
        <v-divider style="opacity: 0.5" />
      </v-col>
    </v-row>
  </v-container>
</template>
